@import '../../theme/global';

:host {
  display: block;
  font-family: $font-family;
  width: 100%;
}

.snap-calendar {
  &-date-picker {
    background-color: $base-light;
    border: 1px solid $gray-300;
    border-radius: 10px;
    box-sizing: border-box;
    margin-top: 0.5rem;
    padding: 1rem;
    position: absolute;
    width: 350px;
    z-index: 10000;

    &.mobile {
      margin: 0 auto;

      .date-picker-footer {
        &.right {
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }

  .date-picker-header {
    color: $gray-800;
    display: flex;
    font-weight: 500;
    justify-content: space-between;
    line-height: 1.5rem;

    .month-container {
      align-items: center;
      display: flex;
      justify-content: space-between;
      width: 80px;

      @media (min-width: map-get($breakpoints, 'md')) {
        width: 165px;
      }
    }

    .month-arrow-container {
      cursor: pointer;
      display: flex;
    }

    .year-container {
      color: #475569;
      display: flex;

      @media (min-width: map-get($breakpoints, 'md')) {
        display: block;
      }

      snap-icon {
        margin-left: 4px;
      }
    }
  }

  .date-picker-body{
    width: 100%;

    .body-pickers-container {
      display: flex;
      padding: 27px 0 28px;
    }
  }

  .date-picker-footer {
    border-top: 1px solid $gray-100;
    margin-top: 10px;
    padding-top: 7px;

    @media (min-width: map-get($breakpoints, 'md')) {
      border: 0;
      margin-top: 1rem;
      padding: 0;
    }

    .date-picker-footer-left {
      display: flex;
      justify-content: space-between;
    }
  }

  .calendar-month {
    color: #666;
    display: flex;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
    width: 100%;
  }

  .calendar-head {
    display: flex;
    height: 40px;
    margin-top: 10px;
    width: 100%;
  }

  .calendar-head-name {
    align-items: center;
    color: $gray-500;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    justify-content: center;
    line-height: 20px;
    text-align: center;
    width: 45px;
  }

  .calendar-body {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .calendar-day-container {
    display: flex;
  }

  .calendar-day {
    display: flex;
    height: 40px;
    justify-content: center;
    width: 45px;
  }

  .calendar-day span {
    align-items: center;
    border-radius: 50%;
    color: $gray-800;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    justify-content: center;
    width: 40px;
  }

  .calendar-day-container.gray .calendar-day span{
    background: $base-light;
    color: $gray-500;
  }

  .calendar-day-container.current .calendar-day span{
    background: $gray-200;

    &:hover {
      background: $blue-800;
    }
  }

  .calendar-day-container.selected .calendar-day span{
    background:$blue-600;
    color: $base-light;
  }

  .calendar-day-container .calendar-day span:hover{
    background: $blue-800;
    color: $base-light;
    cursor: pointer;
  }
}
